// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-page-container {
  --cart-surface: #ffffff;
  --cart-surface-soft: #f7fbff;
  --cart-text: #10273f;
  --cart-muted: #667f97;
  --cart-border: #d8e7f6;
  --cart-brand: #0f62ad;
  --cart-brand-dark: #0b4f8e;
  --cart-danger: #ef4d3c;
  --cart-shadow-soft: 0 10px 26px rgba(13, 36, 64, 0.08);
  --cart-shadow-raise: 0 16px 34px rgba(13, 36, 64, 0.13);
  width: min(96%, 1220px);
  margin: 20px auto 0;
  padding: 0;
  color: var(--cart-text);
}

.cart-page-header {
  margin-bottom: 14px;
}

.cart-page-header h1 {
  margin: 0;
  font-size: clamp(1.6rem, 2.3vw, 2.1rem);
  color: var(--cart-text);
  letter-spacing: 0.2px;
}

.cart-page-header p {
  margin: 8px 0 0;
  color: var(--cart-muted);
  font-size: 0.98rem;
}

.cart-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 18px;
  align-items: start;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cart-item {
  display: grid;
  grid-template-columns: 118px minmax(0, 1fr) auto;
  gap: 16px;
  background: var(--cart-surface);
  border: 1px solid var(--cart-border);
  box-shadow: var(--cart-shadow-soft);
  padding: 14px;
  border-radius: 14px;
  align-items: center;
}

.cart-item:hover {
  box-shadow: var(--cart-shadow-raise);
  border-color: #bfd7ee;
}

.cart-item img {
  width: 118px;
  height: 118px;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid #e2ecf8;
  background: var(--cart-surface-soft);
  padding: 8px;
  box-sizing: border-box;
}

.cart-item-info {
  min-width: 0;
}

.cart-item-info h3 {
  margin: 0;
  font-size: 1rem;
  line-height: 1.35;
  color: var(--cart-text);
}

.cart-item-info p {
  margin: 6px 0;
  font-size: 0.92rem;
  color: var(--cart-muted);
}

.quantity-controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  padding: 6px;
  border-radius: 10px;
  border: 1px solid #d8e6f5;
  background: #f2f8ff;
}

.quantity-controls button {
  width: 30px;
  height: 30px;
  font-size: 16px;
  border: 1px solid #c9dced;
  background: #ffffff;
  cursor: pointer;
  border-radius: 8px;
  color: var(--cart-brand-dark);
  font-weight: 700;
}

.quantity-controls button:hover {
  background: #edf5ff;
}

.quantity-controls span {
  min-width: 18px;
  text-align: center;
  font-weight: 700;
  color: var(--cart-text);
}

.remove-btn {
  margin-top: 10px;
  border: 1px solid #f6c3bc;
  background: #fff4f2;
  color: #cd3f32;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}

.remove-btn:hover {
  background: #ffe9e6;
  border-color: #f2aaa1;
}

.item-total {
  text-align: right;
}

.item-total p {
  margin: 0;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--cart-muted);
}

.item-total strong {
  margin-top: 4px;
  display: block;
  color: var(--cart-brand-dark);
  font-size: 1rem;
}

.cart-summary {
  position: sticky;
  top: 128px;
  padding: 16px;
  border-radius: 14px;
  border: 1px solid var(--cart-border);
  background: var(--cart-surface);
  box-shadow: var(--cart-shadow-soft);
}

.summary-label {
  margin: 0 0 8px;
  color: var(--cart-muted);
  text-transform: uppercase;
  letter-spacing: 0.7px;
  font-size: 11px;
}

.cart-summary h2 {
  margin: 0;
  color: var(--cart-text);
  font-size: 1.2rem;
}

.checkout-btn {
  margin-top: 14px;
  width: 100%;
  min-height: 42px;
  background: linear-gradient(120deg, var(--cart-brand) 0%, var(--cart-brand-dark) 100%);
  color: #ffffff;
  border: none;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  cursor: pointer;
  border-radius: 10px;
}

.checkout-btn:hover {
  filter: brightness(1.05);
}

.cart-empty-state {
  border: 1px solid var(--cart-border);
  box-shadow: var(--cart-shadow-soft);
  background: var(--cart-surface);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
}

.cart-empty-state h2 {
  margin: 0 0 8px;
  color: var(--cart-text);
}

.cart-empty-state p {
  margin: 0;
  color: var(--cart-muted);
}

.cart-empty-state .checkout-btn {
  width: auto;
  padding: 0 18px;
  margin-top: 14px;
}

@media screen and (max-width: 992px) {
  .cart-layout {
    grid-template-columns: 1fr;
  }

  .cart-summary {
    position: static;
  }
}

@media screen and (max-width: 767px) {
  .cart-page-container {
    width: 94%;
    margin-top: 14px;
  }

  .cart-page-header h1 {
    font-size: 1.45rem;
  }

  .cart-item {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .cart-item img {
    width: 100%;
    height: 180px;
  }

  .item-total {
    text-align: left;
  }

  .cart-summary {
    padding: 14px;
  }
}

/* Match shared Footer style with homepage */
.blue-text {
  color: #3391ff;
}

.yellow-text {
  color: #f3bd29;
}

.footer {
  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);
  --footer-text: #e8f0f8;
  --footer-muted: #c7d5e3;
  --footer-border: rgba(255, 255, 255, 0.14);
  --footer-highlight: #f3bd29;
  margin: 70px 0 -12px;
  padding: 40px clamp(18px, 3vw, 42px) 18px;
  color: var(--footer-text);
  background: var(--footer-bg);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.footer-main {
  width: min(1240px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);
  gap: clamp(18px, 3vw, 36px);
  align-items: flex-start;
}

.footer-brand-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.footer-brand img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.footer-brand h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(22px, 2.1vw, 28px);
  letter-spacing: 0.02em;
}

.footer-description {
  margin: 0;
  max-width: 34ch;
  color: var(--footer-muted);
  line-height: 1.65;
  font-size: 14px;
}

.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-contact-list a {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--footer-text);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
}

.footer-contact-list a:hover {
  color: var(--footer-highlight);
}

.footer-contact-list a svg {
  color: var(--footer-highlight);
  flex-shrink: 0;
}

.footer-link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link-group h3,
.footer-social-block h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.footer-link-group a {
  color: var(--footer-muted);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
  transition: color 0.2s ease;
}

.footer-link-group a:hover {
  color: #ffffff;
}

.footer-social-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-social-block p {
  margin: 0;
  color: var(--footer-muted);
  line-height: 1.6;
  font-size: 14px;
}

.footer-social-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 10px;
}

.footer-social-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  border: 1px solid var(--footer-border);
  border-radius: 999px;
  color: #ffffff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.06);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.footer-social-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.26);
}

.footer-bottom {
  width: min(1240px, 100%);
  margin: 28px auto 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: var(--footer-muted);
  font-size: 13px;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 16px;
}

.footer-bottom-links a {
  color: var(--footer-muted);
  text-decoration: none;
}

.footer-bottom-links a:hover {
  color: #ffffff;
}

@media screen and (max-width: 1080px) {
  .footer-main {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media screen and (max-width: 768px) {
  .footer {
    margin-top: 48px;
    padding: 30px 16px 90px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-social-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
  }

  .footer-bottom-links {
    gap: 12px;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AddtoCart/addtocart.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,uDAAuD;EACvD,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sFAAsF;EACtF,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2EAA2E;EAC3E,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,6CAA6C;EAC7C,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,sGAAsG;EACtG,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".cart-page-container {\n  --cart-surface: #ffffff;\n  --cart-surface-soft: #f7fbff;\n  --cart-text: #10273f;\n  --cart-muted: #667f97;\n  --cart-border: #d8e7f6;\n  --cart-brand: #0f62ad;\n  --cart-brand-dark: #0b4f8e;\n  --cart-danger: #ef4d3c;\n  --cart-shadow-soft: 0 10px 26px rgba(13, 36, 64, 0.08);\n  --cart-shadow-raise: 0 16px 34px rgba(13, 36, 64, 0.13);\n  width: min(96%, 1220px);\n  margin: 20px auto 0;\n  padding: 0;\n  color: var(--cart-text);\n}\n\n.cart-page-header {\n  margin-bottom: 14px;\n}\n\n.cart-page-header h1 {\n  margin: 0;\n  font-size: clamp(1.6rem, 2.3vw, 2.1rem);\n  color: var(--cart-text);\n  letter-spacing: 0.2px;\n}\n\n.cart-page-header p {\n  margin: 8px 0 0;\n  color: var(--cart-muted);\n  font-size: 0.98rem;\n}\n\n.cart-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 18px;\n  align-items: start;\n}\n\n.cart-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cart-item {\n  display: grid;\n  grid-template-columns: 118px minmax(0, 1fr) auto;\n  gap: 16px;\n  background: var(--cart-surface);\n  border: 1px solid var(--cart-border);\n  box-shadow: var(--cart-shadow-soft);\n  padding: 14px;\n  border-radius: 14px;\n  align-items: center;\n}\n\n.cart-item:hover {\n  box-shadow: var(--cart-shadow-raise);\n  border-color: #bfd7ee;\n}\n\n.cart-item img {\n  width: 118px;\n  height: 118px;\n  object-fit: contain;\n  border-radius: 12px;\n  border: 1px solid #e2ecf8;\n  background: var(--cart-surface-soft);\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.cart-item-info {\n  min-width: 0;\n}\n\n.cart-item-info h3 {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.35;\n  color: var(--cart-text);\n}\n\n.cart-item-info p {\n  margin: 6px 0;\n  font-size: 0.92rem;\n  color: var(--cart-muted);\n}\n\n.quantity-controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n  padding: 6px;\n  border-radius: 10px;\n  border: 1px solid #d8e6f5;\n  background: #f2f8ff;\n}\n\n.quantity-controls button {\n  width: 30px;\n  height: 30px;\n  font-size: 16px;\n  border: 1px solid #c9dced;\n  background: #ffffff;\n  cursor: pointer;\n  border-radius: 8px;\n  color: var(--cart-brand-dark);\n  font-weight: 700;\n}\n\n.quantity-controls button:hover {\n  background: #edf5ff;\n}\n\n.quantity-controls span {\n  min-width: 18px;\n  text-align: center;\n  font-weight: 700;\n  color: var(--cart-text);\n}\n\n.remove-btn {\n  margin-top: 10px;\n  border: 1px solid #f6c3bc;\n  background: #fff4f2;\n  color: #cd3f32;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.remove-btn:hover {\n  background: #ffe9e6;\n  border-color: #f2aaa1;\n}\n\n.item-total {\n  text-align: right;\n}\n\n.item-total p {\n  margin: 0;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--cart-muted);\n}\n\n.item-total strong {\n  margin-top: 4px;\n  display: block;\n  color: var(--cart-brand-dark);\n  font-size: 1rem;\n}\n\n.cart-summary {\n  position: sticky;\n  top: 128px;\n  padding: 16px;\n  border-radius: 14px;\n  border: 1px solid var(--cart-border);\n  background: var(--cart-surface);\n  box-shadow: var(--cart-shadow-soft);\n}\n\n.summary-label {\n  margin: 0 0 8px;\n  color: var(--cart-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  font-size: 11px;\n}\n\n.cart-summary h2 {\n  margin: 0;\n  color: var(--cart-text);\n  font-size: 1.2rem;\n}\n\n.checkout-btn {\n  margin-top: 14px;\n  width: 100%;\n  min-height: 42px;\n  background: linear-gradient(120deg, var(--cart-brand) 0%, var(--cart-brand-dark) 100%);\n  color: #ffffff;\n  border: none;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\n.checkout-btn:hover {\n  filter: brightness(1.05);\n}\n\n.cart-empty-state {\n  border: 1px solid var(--cart-border);\n  box-shadow: var(--cart-shadow-soft);\n  background: var(--cart-surface);\n  border-radius: 16px;\n  padding: 24px;\n  text-align: center;\n}\n\n.cart-empty-state h2 {\n  margin: 0 0 8px;\n  color: var(--cart-text);\n}\n\n.cart-empty-state p {\n  margin: 0;\n  color: var(--cart-muted);\n}\n\n.cart-empty-state .checkout-btn {\n  width: auto;\n  padding: 0 18px;\n  margin-top: 14px;\n}\n\n@media screen and (max-width: 992px) {\n  .cart-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .cart-summary {\n    position: static;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .cart-page-container {\n    width: 94%;\n    margin-top: 14px;\n  }\n\n  .cart-page-header h1 {\n    font-size: 1.45rem;\n  }\n\n  .cart-item {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .cart-item img {\n    width: 100%;\n    height: 180px;\n  }\n\n  .item-total {\n    text-align: left;\n  }\n\n  .cart-summary {\n    padding: 14px;\n  }\n}\n\n/* Match shared Footer style with homepage */\n.blue-text {\n  color: #3391ff;\n}\n\n.yellow-text {\n  color: #f3bd29;\n}\n\n.footer {\n  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);\n  --footer-text: #e8f0f8;\n  --footer-muted: #c7d5e3;\n  --footer-border: rgba(255, 255, 255, 0.14);\n  --footer-highlight: #f3bd29;\n  margin: 70px 0 -12px;\n  padding: 40px clamp(18px, 3vw, 42px) 18px;\n  color: var(--footer-text);\n  background: var(--footer-bg);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.footer-main {\n  width: min(1240px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);\n  gap: clamp(18px, 3vw, 36px);\n  align-items: flex-start;\n}\n\n.footer-brand-block {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.footer-brand img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.footer-brand h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(22px, 2.1vw, 28px);\n  letter-spacing: 0.02em;\n}\n\n.footer-description {\n  margin: 0;\n  max-width: 34ch;\n  color: var(--footer-muted);\n  line-height: 1.65;\n  font-size: 14px;\n}\n\n.footer-contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-contact-list a {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--footer-text);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n}\n\n.footer-contact-list a:hover {\n  color: var(--footer-highlight);\n}\n\n.footer-contact-list a svg {\n  color: var(--footer-highlight);\n  flex-shrink: 0;\n}\n\n.footer-link-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-link-group h3,\n.footer-social-block h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n}\n\n.footer-link-group a {\n  color: var(--footer-muted);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n  transition: color 0.2s ease;\n}\n\n.footer-link-group a:hover {\n  color: #ffffff;\n}\n\n.footer-social-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-social-block p {\n  margin: 0;\n  color: var(--footer-muted);\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.footer-social-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.footer-social-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 42px;\n  border: 1px solid var(--footer-border);\n  border-radius: 999px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.06);\n  transition:\n    transform 0.2s ease,\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.footer-social-item:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.26);\n}\n\n.footer-bottom {\n  width: min(1240px, 100%);\n  margin: 28px auto 0;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  color: var(--footer-muted);\n  font-size: 13px;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.footer-bottom-links a {\n  color: var(--footer-muted);\n  text-decoration: none;\n}\n\n.footer-bottom-links a:hover {\n  color: #ffffff;\n}\n\n@media screen and (max-width: 1080px) {\n  .footer-main {\n    grid-template-columns: repeat(2, minmax(220px, 1fr));\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .footer {\n    margin-top: 48px;\n    padding: 30px 16px 90px;\n  }\n\n  .footer-main {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .footer-social-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 12px;\n  }\n\n  .footer-bottom-links {\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
